module.exports = "<div class=\"router-outlet-container\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n<app-modal-component></app-modal-component>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main